const URL = {
    liveTvUrl: process.env.REACT_APP_LIVE_TV_URL || "",
    liveScoreUrl: process.env.REACT_APP_LIVE_SCORE_URL || "",
    whatsAppSupportUrl: process.env.REACT_APP_WHATSAPP_SUPPORT_URL || "",
    telegramSupportUrl: process.env.REACT_APP_TG_SUPPORT_URL || "",
    instagramSupportUrl: process.env.REACT_APP_IG_SUPPORT_URL || "",
    closeIconUrl: process.env.REACT_APP_CLOSE_ICON_URL || "",
    marketDepthChartUrl: process.env.REACT_APP_MARKET_DEPTH_CHART_IMAGE || "",
    youtubeLiveUrl: process.env.REACT_APP_YOUTUBE_LIVE_URL || "",
    virtualCricketUrl: process.env.REACT_APP_VIRTUAL_CRICKET_URL || "",
    ipWhoUrl: process.env.REACT_APP_IP_WHO_URL || "",
}
export default URL;